"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WScrollTo = exports.SyncTestUrl = exports.SyncSeek_action = exports.SyncSeekUrlPOSTobject = exports.SyncSeekUrl = exports.SyncPush_action = exports.SyncPushSerialized_action = exports.SyncPushSerializedUrl = exports.SyncPull_action = exports.SyncPullSerialized_action = exports.SyncPullSerializedUrl = exports.SyncPassThru_action = exports.SyncPassThruUrl = exports.SyncMakeGetUrl = exports.SyncGuid_action = exports.SyncDelete_action = exports.SyncDeleteUrl = exports.SetCookieByName = exports.RedirectTo = exports.Randomize = exports.IsAdmin = exports.GetCurrentUser = exports.GetCurrentGuest = exports.GetCookieByName = exports.DisconnectUser = exports.CTimeStamp = exports.CGUID = exports.Assert = void 0;
var _reactstrap = require("reactstrap");
var _universalCookie = _interopRequireDefault(require("universal-cookie"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const cookie_debugging = false;
const cookies = new _universalCookie.default();
const _seconds = 1;
const _minutes = 60 * _seconds;
const Assert = (p_any_expression, p_o_parameters) => {
  if (!p_any_expression) {
    if (p_o_parameters && !p_o_parameters.silent) (0, _reactstrap.Alert)("Assertion not verified in expression");
    throw new Error(`${p_any_expression} assertion not fullfilled !`);
  }
  return true;
};
exports.Assert = Assert;
const l_build_data_sync_webmethod_url = (home, action) => {
  return `${home ? home : "https://rest.datasync.ovh"}/${action}`;
};
const SyncTestUrl = home => {
  return l_build_data_sync_webmethod_url(home, "test.php");
};
exports.SyncTestUrl = SyncTestUrl;
const SyncPushSerializedUrl = home => {
  return l_build_data_sync_webmethod_url(home, "Sync.php");
};
exports.SyncPushSerializedUrl = SyncPushSerializedUrl;
const SyncDeleteUrl = home => {
  return l_build_data_sync_webmethod_url(home, "Sync.php?action=syncDelete");
};
exports.SyncDeleteUrl = SyncDeleteUrl;
const SyncSeekUrl = home => {
  return l_build_data_sync_webmethod_url(home, "Sync.php?action=syncSeek");
};
exports.SyncSeekUrl = SyncSeekUrl;
const SyncSeekUrlPOSTobject = datasync_url => {
  return {
    POST_URL: `${datasync_url}/Sync.php`,
    POST_ACTION: "syncSeek"
  };
};
exports.SyncSeekUrlPOSTobject = SyncSeekUrlPOSTobject;
const SyncPullSerializedUrl = home => {
  return l_build_data_sync_webmethod_url(home, "Sync.php?action=syncPullSerialized");
};
exports.SyncPullSerializedUrl = SyncPullSerializedUrl;
const SyncPassThruUrl = home => {
  return l_build_data_sync_webmethod_url(home, "Sync.php?action=syncPassThru");
};
exports.SyncPassThruUrl = SyncPassThruUrl;
const SyncMakeGetUrl = (home, action) => {
  return `${home ? home : "https://rest.datasync.ovh"}/Sync.php?action=${action}`;
};
exports.SyncMakeGetUrl = SyncMakeGetUrl;
const SyncGuid_action = exports.SyncGuid_action = "syncGuid";
const SyncPush_action = exports.SyncPush_action = "syncPush";
const SyncDelete_action = exports.SyncDelete_action = "syncDelete";
const SyncPassThru_action = exports.SyncPassThru_action = "syncPassThru";
const SyncSeek_action = exports.SyncSeek_action = "syncSeek";
const SyncPull_action = exports.SyncPull_action = "syncPull";
const SyncPullSerialized_action = exports.SyncPullSerialized_action = "syncPullSerialized";
const SyncPushSerialized_action = exports.SyncPushSerialized_action = "syncPushSerialized";

/**
 * Prototype : SetCookieByName
 * Purpose : Set a given cookie name with an object value
 * @param {*} p_s_cookie_name 
 * @param {*} p_o_cookie_value 
 */
const SetCookieByName = (p_s_cookie_name, p_o_cookie_value) => {
  if (p_s_cookie_name == null) {
    alert("SetCookieByName p_s_cookie_name not set !");
  }
  cookies.set(p_s_cookie_name, p_o_cookie_value, {
    path: '/',
    maxAge: 300 * _minutes
  });
  if (cookie_debugging) {
    console.log(`Globals::SetCookieByName "${p_s_cookie_name}" set with value "${JSON.stringify(p_o_cookie_value)}"`);
  }
};

/**
 * Prototype : GetCookieByName
 * Purpose : Returns given cookie name values
 * @param {*} p_s_cookie_name 
 * @param {*} p_sTargetRedirectionFallbackURL redirection url when cookie is null
 * @returns 
 */
exports.SetCookieByName = SetCookieByName;
const GetCookieByName = (p_s_cookie_name, p_sTargetRedirectionFallbackURL) => {
  let cookie_value = cookies.get(p_s_cookie_name);
  if (cookie_debugging) {
    console.log(`cookie ${p_s_cookie_name} as p_sTargetRedirectionFallbackURL -> ${p_sTargetRedirectionFallbackURL}`);
  }
  if (cookie_value == "null" || typeof cookie_value != "object") {
    if (p_sTargetRedirectionFallbackURL) RedirectTo(p_sTargetRedirectionFallbackURL);
    return null; //Check for valid object
  }
  try {
    if (cookie_debugging) {
      console.log(`cookie ${p_s_cookie_name} as string ${JSON.stringify(cookie_value)}`);
    }

    //Check JSON object validity
    let l_sJSONcheck = JSON.stringify(cookie_value);
  } catch (e) {
    console.error(`GetCookieByName -> Invalide cookie ${p_s_cookie_name}`);
    return null;
  }
  return cookie_value;
};

/**
 * GetCurrentUser
 * @param (*) p_bool_do_not_fallback_to_home when set redirection is ignored, by default redirection will be performed
 * @returns connected user object if connected, null otherwise
 */
exports.GetCookieByName = GetCookieByName;
const GetCurrentUser = (p_user_cookie_name, p_bool_do_not_fallback_to_home) => {
  try {
    let l_oUserCookie = GetCookieByName(p_user_cookie_name, p_bool_do_not_fallback_to_home ? null : "/login-page");
    if (cookie_debugging) console.log("l_oUserCookie:", l_oUserCookie);
    return l_oUserCookie ? l_oUserCookie : null;
  } catch (e) {
    return null;
  }
};

/**
 * GetCurrentGuest
 * @param (*) p_bool_do_not_fallback_to_home when set redirection is ignored, by default redirection will be performed
 * @returns connected guest object if connected, null otherwise
 */
exports.GetCurrentUser = GetCurrentUser;
const GetCurrentGuest = p_bool_do_not_fallback_to_home => {
  try {
    let l_oGuestCookie = GetCookieByName(_guest_cookie_name, p_bool_do_not_fallback_to_home ? null : "/login-page");
    if (cookie_debugging) console.log("l_oUserCookie:", l_oGuestCookie);
    return l_oGuestCookie ? l_oGuestCookie : null;
  } catch (e) {
    return null;
  }
};

/**
 * 
 * @param {OBSOLETE} cookie_value 
 */
exports.GetCurrentGuest = GetCurrentGuest;
const DisconnectUser = p_user_cookie_name => {
  SetCookieByName(p_user_cookie_name, null);
  if (cookie_debugging) {
    console.log(`cookie value reset`);
  }
  console.log("Disconnect then reconnect");
  //redirect to home page
  window.open(GetCurrentUser() ? "/admin" : "/", '_self', 'noopener,noreferrer');
};

/**
 * 
 * @returns 
 */
exports.DisconnectUser = DisconnectUser;
const IsAdmin = () => {
  let l_oConnectedUser = GetCurrentUser();
  return l_oConnectedUser ? l_oConnectedUser.admin == "Oui" : false;
};

/* Prototype 	: CGUID
* Purpose 		: Generates a Global Unique ID
* Return		  :	Return GUID
* History   	: Created on 2015-02-06
*
**/
exports.IsAdmin = IsAdmin;
const CGUID = () => {
  let d = new Date().getTime();
  let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
};

/***
* Prototype 	: 	CTimeStamp
* Purpose 		: 	return TimeStamp as "AAAA-MM-JJ HHMMSS" format
* History		: 	Created on 2014-08-06
*
**/
exports.CGUID = CGUID;
const CTimeStamp = () => {
  let lDate = new Date();
  let l_sTimeStamp = '';
  l_sTimeStamp = 1900 + lDate.getYear();
  l_sTimeStamp += '-';
  l_sTimeStamp += ('0' + (lDate.getMonth() + 1)).slice(-2);
  l_sTimeStamp += '-';
  l_sTimeStamp += ('0' + lDate.getDate()).slice(-2);
  l_sTimeStamp += ' ';
  l_sTimeStamp += ('0' + lDate.getHours()).slice(-2);
  l_sTimeStamp += ('0' + lDate.getMinutes()).slice(-2);
  l_sTimeStamp += ('0' + lDate.getSeconds()).slice(-2);
  return l_sTimeStamp;
};

/**
   * Prototype : RedirectTo
   * @param {*} target 
   */
exports.CTimeStamp = CTimeStamp;
const RedirectTo = target => {
  window.open(target, '_self', 'noopener,noreferrer');
};

/**
 * Prototype : WScrollTo
 * @param {*} pStargetAnchorId 
 */
exports.RedirectTo = RedirectTo;
const WScrollTo = pStargetAnchorId => {
  let targetDomAnchor = document.getElementById(pStargetAnchorId);
  if (targetDomAnchor) targetDomAnchor.scrollIntoView({
    behavior: "smooth",
    block: "start",
    inline: "nearest"
  });else {
    console.log(`WScrollTo failed => ${pStargetAnchorId} not found in DOM !`);
  }
};
exports.WScrollTo = WScrollTo;
const Randomize = (min, max) => {
  return Math.floor(min + Math.random() * (max - min));
};
exports.Randomize = Randomize;